<div class="card">
  <div class="flex items-center gap-3">
    <h5 class="font-bold">Pagamento</h5>
    <div class="w-fit">
      <app-tag-status
        [status]="downPaymentTag().status"
        [text]="downPaymentTag().text"
      ></app-tag-status>
    </div>
  </div>

  @if (paymentAttempts().length) {
    <p-table
      [value]="paymentAttempts()"
      [showGridlines]="true"
      styleClass="mt-3"
    >
      <ng-template #header>
        <tr>
          <th class="bg-gray-200!">Data</th>
          <th class="bg-gray-200!">Método de Pagamento</th>
          <th class="bg-gray-200!">Dados do Pagamento</th>
          <th class="bg-gray-200!">Valor</th>
          <th class="bg-gray-200!">Status</th>
        </tr>
      </ng-template>
      <ng-template #body let-attempt>
        <tr>
          <td>{{ attempt.date | date: "dd/MM/yyyy HH:mm" }}</td>
          <td>{{ attempt.method }}</td>
          <td>
            @if (attempt.card) {
              {{ attempt.card.brand | titlecase }} ••••
              {{ attempt.card.displayNumber }}
            } @else {
              -
            }
          </td>
          <td>{{ attempt.amount | currency }}</td>
          <td>
            <div class="w-fit">
              <app-tag-status
                [status]="attempt.statusTag"
                [text]="attempt.status"
              ></app-tag-status>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p class="mt-3">Nenhum pagamento registrado</p>
  }
</div>
